import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import LoadingSpinner from '../../../components/LoadingSpinner'
import type { RootState } from '../../../store'
import { clearAuth, setAuthenticated } from '../../../store/slices/authSlice'
import { useAuth } from '../hooks/useAuth'
import { useFamilyMemberId } from '../hooks/useFamilyMemberId'

const IDENTITY_VERIFIED_KEY = 'familyPortal.identityVerified'

export type AuthGuardProps = {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth()
  const dispatch = useDispatch()
  const authState = useSelector((state: RootState) => state.auth)
  useFamilyMemberId()

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(setAuthenticated({ isAuthenticated: true, userEmail: user?.email }))
    } else if (!isLoading) {
      // Only clear verification flag on actual logout, not during auth rehydration (e.g. refresh)
      sessionStorage.removeItem(IDENTITY_VERIFIED_KEY)
      dispatch(clearAuth())
    }
  }, [isAuthenticated, isLoading, user?.email, dispatch])

  useEffect(() => {
    if (isAuthenticated) {
      console.log('[AuthGuard] Redux auth state after login:', authState)
    }
  }, [isAuthenticated, authState])

  if (isLoading) {
    return <LoadingSpinner label="Loading…" />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default AuthGuard
